import { lazy, Suspense } from "react"

import { IconSvg, type IconSvgProps } from "./icon"
import type { IconName } from "./icon-names"

export interface NamedIconProps extends IconSvgProps {
  name: IconName
}

// The registry holds every icon, so it loads as its own chunk the first time a
// NamedIcon renders, instead of riding in the shared bundle. On a server-rendered
// page the icon's HTML stays in place until the chunk arrives.
const RegistryIcon = lazy(() => import("./registry-icon"))

/**
 * Renders an icon by name. Use it only when the name is data, such as an entity
 * category from `entity-icons.json`. Otherwise import the icon component
 * directly, so the page bundles only the icons it uses.
 */
export function NamedIcon({ name, ...props }: NamedIconProps) {
  return (
    // The fallback is an empty icon with the same box, so nothing shifts while
    // the registry chunk loads.
    <Suspense fallback={<IconSvg {...props} />}>
      <RegistryIcon name={name} {...props} />
    </Suspense>
  )
}
